import { Outlet, useNavigate } from "react-router-dom";
import DashNav from "@/components/DashNav";
import Footer from "@/components/Footer";
import { CartProvider } from "@/hooks/useCart";
import "react-toastify/dist/ReactToastify.css";
import { useAuthModal } from "@/components/AuthModal";
import { useEffect } from "react";
import useAuth from "../hooks/useAuth";

const MainLayout = () => {
    const { openAuthModal } = useAuthModal();
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            openAuthModal();
            navigate("/");
        }
    }, [user]);

    return user ? (
        <>
            <CartProvider businessName={"Bunchiz"}>
                <header className="pb-6 bg-shade-light">
                    <div className="w-full h-6 bg-primary" />
                    <h1 className="padding-x bg-white py-4 text-2xl font-bold">
                        Welcome Back <span className="text-primary">{user.data.fname}</span>.
                    </h1>
                    <hr />
                    <DashNav />
                </header>
                <main className="bg-shade-light">
                    <Outlet />
                </main>
                <Footer />
            </CartProvider>
        </>
    ) : null;
};
export default MainLayout;
